import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { themeQuartz } from 'ag-grid-community';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare';
import { DateCellRenderer, LinkCellRenderer } from '../components/grid/CellRenderers';
import { useMsal } from '@azure/msal-react';
import { fetchAuthorized } from '../utils/fetchAuthorized';
import { AddEnterprise } from '../components/client/AddEnterprise';
import PaginationGrid from '../components/grid/PaginationGrid';

const LinkComponent = (props) => {
  return (
    <Link className="btn-primary" to={`/Enterprises/${props.value}`}>
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="lg" />
    </Link>
  );
}

export function EnterprisesPage() {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalEnterpriseCount, setTotalEnterpriseCount] = useState(0);
  const [enterprises, setEnterprises] = useState([]);

  const getEnterpriseCount = async () => {
    try {
      if(totalEnterpriseCount > 0) return;
      const response = await fetchAuthorized(instance, `${process.env.REACT_APP_API_URL}enterprises/count`)
      if(!response.ok) {
        throw new Error('Could not retrieve enterprise count.');
      }
      const data = await response.json();
      setTotalEnterpriseCount(data);
    } catch (error) {
      setError(error.message);
    }
  };

  const getEnterprises = async (pageNumber, pageSize, sortField, sortDirection) => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL}enterprises?pageNumber=${pageNumber}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`;
      const response = await fetchAuthorized(instance, url);
      if(!response.ok) {
        throw new Error('Could not retrieve enterprises.');
      }
      const data = await response.json();
      setEnterprises(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(enterprises && enterprises.length > 0)
        return;
    getEnterpriseCount();
    getEnterprises(1, 12, 'createdDate', 'desc');
  }, []);
  

  const columnDefs = [
    { field: "name", filter: false, flex: 1, cellRenderer: LinkCellRenderer, cellRendererParams: { baseUrl: '/Enterprises/' } },
    { field: "createdDate", headerName: "Created Date", cellDataType: 'date', filter: false, flex: 1, cellRenderer: DateCellRenderer },
    { field: "type", headerName: "Type", cellDataType: 'string',  filter: false, flex: 1 },
    { field: "size", headerName: "Size", cellDataType: 'string',  filter: false, flex: 1 },
    { field: "industry", headerName: "Industry", cellDataType: 'string',  filter: false, flex: 1 },
    { field: "annualRevenue", headerName: "Annual Revenue", cellDataType: 'string',  filter: false, flex: 1 },
    { field: "id", headerName: "", cellClass: "justify-content-center", cellRenderer: LinkComponent }
  ];

  return (
    <div className="container-fluid px-5 d-flex flex-column">
      <h2>Enterprises</h2>
      {
        error ? (
          <p>Error: {error}</p>
        ) : (
          <PaginationGrid
            gridId="enterprise-grid"
            theme={themeQuartz}
            rowData={enterprises}
            columnDefs={columnDefs}
            rowHeight={50}
            loading={loading}
            totalRows={totalEnterpriseCount}
            getData={getEnterprises}
          />
        )
      }
      { !loading && 
        <AddEnterprise
          modal
          enterprises={enterprises}
          handleAddEnterprise={(value) => setEnterprises([value, ...enterprises])}
        />
      }
    </div>
  );
}
